export const baseTranslationsEn = {
  app: "App",
  home: "Startpage",
  login: "Login",
  logout: "Logout",
  user: "User",
  none: "None",
  language: "Language",
  role: "Role",
  roles: "Roles",
  username: "Username",
  email: "E-Mail",
  firstname: "First name",
  lastname: "Surname",
  addUser: "Add user",
  editUser: "Edit user",
  password: "Password",
  forgotPassword: "Forgot password?",
  loginErrorTitle: "Login Fehler",
  loginEmailError: "This username is not associated with any account",
  loginError: "Invalid user credentials",
  loginPassword: "Wrong password",
  userManagement: "User management",
  genericError:
    "An error occurred, please try again in a few minutes or contact your system administrator",
  search: "Search",
  save: "Save",
  cancel: "Cancel",
  unchanged: "Unchanged",
  parameters: "Parameters",
  oneWeek: "One week",
  oneMonth: "One month",
  twoMonth: "Two month",
  threeMonth: "Three month",
  sixMonth: "Six month",
  dragAndDopProperty: "Drag and drop a parameter to show its chart",
  addFile: "Add file",
  name: "Name",
  type: "Type",
  startDate: "Start date",
  endDate: "End date",
  actions: "Actions",
  delete: "Delete",
  confirmDelete: "Confirm Delete",
  error: "Fehler",
  status: "Status",
  page: "Page",
  close: "Close",
  correlation: "Correlation",
  covariance: "Covariance",
  selectedDateRange: "Selected date range",
  min: "Min",
  max: "Max",
  mean: "Mean",
  tendency: "Tendency",
  offset: "Offset",
  weeks: "Week | Weeks",
  years: "Year | Years",
  months: "Month | Months",
  days: "Day | Days",
  hours: "Hour | Hours",
  minutes: "Minute | Minutes",
  seconds: "Second | Seconds",
  apply: "Apply",
  userCreated: "The user has been created",
  changesSaved: "Changes saved successfully",
  confirm: "Confirm",
  confirmDeleteUser: "Please confirm that you want to delete the user {name}",
  editAppSettings: "Edit app settings",
  accessibleBy: "Accessible by:",
  discard: "Discard",
  editAsset: "Edit asset",
  creatingAssetTemplate: "Creating asset template",
  createTemplate: "Create template",
  templateName: "Asset template name",
  create: "Create",
  addField: "Add field",
  text: "Text",
  select: "Selection",
  number: "Number",
  createField: "Create field",
  selectionOptions: "Options",
  editSelectionOptions: "Edit options",
  createSelectionOptions: "Create Options",
  options: "Options",
  add: "Add",
  templateManagement: "Template management",
  editAssetTemplate: "Edit asset {name} template",
  assets: "Assets",
  showInTable: "Visible in the table",
  createdAt: "Created at",
  created: "Created",
  lastEdit: "Last edit",
  saveAndCreateAnother: "Save and create another entry",
  entryAdded: "Entry added",
  title: "Title",
  link: "Link",
  image: "Image",
  appsAdmin: "Apps admin",
  createApp: "Create App",
  defaultLanguage: "Default language",
  noRoles: "No roles",
  noTwinTemplatesExist: "No templates have been created yet.",
  properties: "Properties",
  selectProperty: "Select property",
  addProperty: "Add property",
  refreshInterval: "Refresh interval",
  assetManagement: "Asset management",
  yes: "Yes",
  no: "No",
  active: "Active",
  noActiveVersion: "No active version",
  hierarchy: "Hierarchy",
  back: "Back",
  changelog: "Changelog",
  changelogDescription:
    "A change log of all incoming and outgoing goods in the warehouse.",
  changeType: "Changetype",
  changedAt: "Changed at",
  changedBy: "Changed by",
  changedReason: "Change Reason",
  assetCreated: "Asset created",
  propertyChanges: "Changes",
  id: "ID",
  reports: "Reports",
  twinReportGroups: "Report groups",
  twinReportSettings: "Report settings",
  twinReportSelectGroupFirst: "Please select a group first",
  twinReportSettingSelect: "Select setting",
  twinReportPrefix: "Type prefix",
  twinReportPropertyFilterCustomIds: "Filter properties",
  twinReportReturnProperties: "Result properties",
  twinReportId: "ID",
  twinReportFixedFilterValues: "Fixed filter values",
  twinReportValuesCommaSeparated: "Comma separated values",
  twinReportSettingNameExplanation:
    "Unique internal name for this report configuration",
  twinReportLabelExplanation: "Display name shown as the report tab title",
  twinReportTypeExplanation:
    "Defines which twin types are included using a type prefix. Select a template or enter a prefix manually.",
  twinReportFixedFiltersExplanation:
    "These filters are always applied. Users cannot change them.",
  twinReportUserFiltersExplanation:
    "These filter controls are shown to users in the report interface.",
  twinReportColumnsExplanation:
    "These columns appear in the report result table.",
  twinReportSelectOrTypePrefixHint: "Select a template or enter a type prefix",
  assetReports: "Asset Reports",
  assetChangelog: "Asset Changelogs",
  assetReportsDescription:
    "Overview of all assets and their documentation grouped by asset type",
  assetChangelogReportsDescription:
    "List of changes on asset documentation for the selected time range",
  show: "Show",
  export: "Export",
  filter: "Filter",
  edit: "Edit",
  documents: "Documents",
  addImages: "Use Drag & Drop or click here to add images",
  dropFilesHere: "Drop files here",
  uploadDocument: "Upload document",
  file: "File",
  selectFile: "Select file",
  noFileSelected: "No File Selected",
  editDocument: "Edit document",
  assetType: "Type",
  firstName: "First Name",
  lastName: "Last Name",
  manageInputValues: "Manage input values",
  inputValues: "Input values",
  instances: "Instances",
  mandatory: "Mandatory",
  relation: "Relation",
  selectMultiple: "Select multiple",
  noValues: "There are currently no values",
  noData: "No Data",
  followingFieldsAreRequired: "The following fields are required",
  fillInAllRequiredFields: "Please fill in all required fields",

  category: "Category",
  changesStartDate: "Changes from",
  changesEndDate: "Changes to",
  clickOnShowToViewData: "Click on {0} to view the data",
  results: "Results",
  addRelation: "Add Relation",
  relations: "Relations",
  addItem: "Add {item}",
  editItem: "Edit {item}",
  date: "Date",
  year: "Year",
  yesNo: "Yes/No",
  pleaseEnterItem: "Please enter a {item} to continue.",
  itemAlreadyExists: "This entry already exists",
  usedAsFilterIn: "Used as filter for:",
  confirmDeleteValueList:
    "{valueList} might be used as a filter. If {valueList} is being deleted, all associated values will also be deleted.",
  selectFilterFirst: "Please select a {filter}",
  propertyDeleteNotAvailableDueToFilteredValues:
    "{property} can't be deleted since it is being used as a filter for {filteredProperties}.\n\nPlease delete these fields first",
  spareParts: "Spare parts",
  settings: "Settings",
  myAccount: "My account",
  myData: "Profile data",
  changePassword: "Change password",
  repeatPassword: "Repeat password",
  passwordChanged: "Password changed successfully.",
  passwordMinLength: "The password has to contain at least 8 characters",
  passwordsDontMatch: "The passwords you entered don't match",
  articles: "Articles",
  singleArticles: "Single articles",
  createArticle: "Create article",
  quantityArticle: "Quantity article",
  singleArticleDescription:
    "Articles that are managed separately in single articles, i.e. larger articles like replacement parts",
  quantityArticleDescription:
    "Articles that are managed by quantity i.e. liquids managed in litres or screws in weight",
  editable: "Editable",
  handout: "Handout",
  refill: "Refill",
  transport: "Transport",
  inventory: "Inventory",
  amount: "Amount",
  comment: "Comment",
  warehouse: "Warehouse",
  components: "Components",
  references: "References",
  handoutToUser: "Handed out to",
  storageLocation: "Storage location",

  articleDocumentedCorrectly:
    "Article amount at the documented location is correct",
  articleInventoryDifference: "Amount differs",
  actualInventory: "Actual amount",
  reason: "Reason",
  articleDoesNotExist: "Article does not exist",
  group: "Group",
  groups: "Groups",
  accessRights: "Access rights",
  accessRightsWarehouse: "Acces rights warehouse",
  createGroup: "Create group",
  targetAndSourceAreSame: "Target and source location are the same",
  systemMisconfigured:
    "There is an error in the system configuration, please contact your system administrator",
  ticketViewMissingCustomIds:
    "The ticket view requires the following custom IDs:",
  editableOnCreate: "Editable on create",
  warehouseManager: "Warehouse manager",
  warehouseInfo: "Warehous info",
  done: "Done",
  customId: "Custom id",
  all: "All",
  userCreatableEntriesForInputValues: "Users may dynamically add options",
  inventoryManagement: "Inventory management",
  articleSearch: "Article search",
  addNomenclature: "Add nomenclature",
  createUser: "Create user",
  userExists: "A user with that username or E-Mail already exists",
  // Ticket Management
  myTickets: "My Tickets",
  ticketsAssignedToMe: "Tickets assigned to me",
  priority: "Priority",
  plannedFinish: "Planned finish",
  firstPlannedFinish: "First planned finish",
  createdBy: "Created by",
  assignee: "Assigned to",
  comments: "Comments",
  send: "Send",
  low: "Low",
  medium: "Medium",
  high: "High",
  loadPreviousComments: "Load previous comments",
  createTicket: "Create ticket",
  files: "Files",
  noFiles: "No files",
  noRelations: "No relations",
  requester: "Requester",
  takeInProcess: "Process",
  reject: "Reject",
  complete: "Complete",
  validate: "Validate",
  invalidate: "Invalidate",
  longComment: "Details",
  createDraft: "Create draft",
  submitDraft: "Submit draft",
  draft: "Draft",
  submit: "Submit",
  rejected: "Rejected",
  new: "New",
  "in process": "In process",
  completed: "Completed",
  notCompleted: "Not completed",
  confirmed: "Confirmed",
  plan: "Plan",
  planned: "Planned",
  reopen: "Reopen",
  myRequests: "My requests",
  assignedToMe: "Assigned to me",
  assetManager: "Asset manager",
  assetInfo: "Asset info",
  maintenance: "Maintenance",
  asset: "Asset",
  location: "location",
  assetOrLocation: "Asset or location",
  reportedBy: "Reported by",
  damageDescription: "Damage description",
  workCarriedOut: "Work done",
  ticketAdmin: "Ticket processing",
  sopManagement: "Task Management",
  enterWorkCarriedOutBeforeCompleting:
    "Please enter the work carried out before completing the ticket.",
  enterWorkDurationBeforeCompleting:
    "Please enter the work duration before completing the ticket.",
  createPlan: "Create plan",
  repetition: "Repetition",
  createMaintenancePlan: "Create maintenance plan",
  editMaintenancePlan: "Edit maintenance plan",
  leadDuration: "Lead duration",
  sop: "Tasks",
  createSop: "Create tasks",
  maintenancePlans: "Maintenance plans",
  timespan: "Timespan",
  firstActivation: "First activation",
  leadDurationDescription:
    "Duration the ticket should be created before the planned finish. I.e. if this is set to 1 month, the ticket for this maintenance process will be created 1 month before the due date.",
  ticketName: "Ticket name",
  ticketDescription: "Ticket description",
  confirmDeleteMaintenancePlan:
    "Please confirm that you want to delete the maintenance plan {name}",
  addSop: "Add task",
  addChecklist: "Add checklist",
  checklistName: "Checklist name",
  addEntry: "Add entry",
  checklist: "Checklist",
  createTicketForTask: "Create a ticket for this task",
  ticketTemplate: "Ticket template",
  transferToTicket: "Transfer to ticket",
  sops: "Tasks",
  tasks: "Tasks",
  addMaterial: "Add material",
  materialUse: "Material use",
  feedback: "Feedback",
  completeTodoListItem: "Complete todo list item",
  itemsAvailable: "{items} available",
  createSopVersion: "Add tasks version",
  manageSopVersions: "Manage tasks versions",
  firstActivatedAt: "First activation",
  activation: "Activation",
  confirmActivateVersion: "Please confirm you want to {0} {1}",

  activateSopVersion: "Activate tasks version",
  deactivateSopVersion: "Deactivate tasks version",
  activate: "Activate",
  deactivate: "Deactivate",
  activateAll: "Activate all",
  deactivateAll: "Deactivate all",
  editSop: "Edit tasks {name}",
  completionTracking: "Completion tracking",
  createTask: "Create task",
  tasklist: "Task list",
  task: "Task",
  sopNotEditable:
    "These tasks are not editable, since they have already been used. To edit these tasks, create a new version.",
  editTask: "Edit task",
  version: "Version",
  versionActivated: "Version activated",
  versionDeactivated: "Version deactivated",
  nOfMTasksCompleted: "({n}/{m}) Tasks completed",
  Permission: "Permission",
  Permissions: "Permissions",
  UniqueID: "Unique ID",
  Accesstype: "Access type",
  writeAccess: "write",
  readAccess: "read",
  chooseDifferentArticle: "choose different article",
  removeArticleFromWarehouse: "Remove this article from the warehouse",
  errorRemovingArticleFromWarehouse:
    "The article could not be removed from the warehouse, please naigate to the warehouse and document the handout.",
  damageNotice: "Damage report",
  ticketType: "Ticket type",
  ticketNumber: "Ticket No.",
  qmdocuments: "Quality management documents",
  customer: "Customer",
  addDocument: "Add document",
  inProcess: "In process",
  atCustomer: "At customer",
  finished: "finished",
  accepted: "Accepted",
  content: "Content",
  proposal: "Proposed content",
  dataSources: "Data sources",
  accept: "Accept",
  rewrite: "Rewrite",
  filename: "Filename",
  itAssets: "IT assets",
  itAssetChangelog: "IT asset changelog",
  inspection: "Inspection",
  itAssetManager: "IT asset manager",
  itAssetInfo: "IT asset informationen",
  maintenancePlanNotEditable:
    "This maintenance plan is currently not editable since it is active.",
  upload: "Upload",
  downloadTemplate: "Vorlage herunterladen",
  uploadCompleted: "Upload completed",
  maintenancePlanStartDateHasToBeInTheFutureToActivate:
    "The due date has to be in the future in order to activate a plan",
  paragraphs: "Paragraphs",
  addParagraph: "Add paragraph",
  processing: "Processing...",
  proposedContent: "Proposed content",
  sentenceDetails: "Details",
  addCustomContentProposal: "Add custom content",
  addContentAndAccept: "Add content proposal",
  useProposedContent: "Use proposal",

  groupManagement: "Group Management",
  permissions: "Permissions",
  permission: "Permission",
  appRoles: "App Roles",
  label: "Label",
  path: "Path",
  protocol: "Protocol",
  selection: "Selection",
  addPermission: "Add Permission",
  clientId: "Client ID",
  howSatisfiedAreYouWithTheProposal: "How satisfied are you with the proposal?",
  unsatisfied: "Unsatisfied",
  notSatisfied: "Not Satisfied",
  mostlySatisfied: "Mostly satisfied",
  satisfied: "Satisfied",
  verySatisfied: "Very satisfied",
  editParagraph: "Edit Paragraph",
  editParagraphWarning:
    "When editing the whole paragraph, all current changes to sentences are lost.",
  addRoles: "Add roles",
  addCustomerResponse: "Add customer response",
  editedVersion: "Edited version",
  similarSnippets: "Similar snippets",
  suggestion: "Suggestion",
  document: "Document",
  customerResponse: "Customer response",
  declined: "Declined",
  confirmDeleteItem: "Please confirm you want to delete {item}.",
  noSuggestion: "No suggestion",
  categories: "Categories",
  DE: "German",
  EN: "English",
  createTranslation: "Create translation",
  createTopic: "Create topic",
  editCategoryName: "Edit category {name}",
  default: "Default",
  topic: "Topic",
  categoryIsAlreadyInUse:
    "The category can't be deleted since it is already being used",
  warehouseTransfer: "Warehouse transfer",
  constraint: "Constraint",
  single: "Single",
  multiple: "Multiple",
  template: "Template",
  calendar: "Calendar",
  duration: "Duration",
  workDuration: "Work duration",
  cloneTemplate: "Clone template",
  confirmCloneTemplate: "Are you sure you want to clone the {name} template?",
  ticketSearch: "Ticket search",
  onlyImagesAreAllowed: "Upload is restricted to images",
  errorUpdatingPassword: "Error updating the password",
  technicalSpecificationsAndEquipmentEngineeringDocuments:
    "Technical Specifications and Equipment Engineering Documents",
  equipmentLifecycleDocumentationAndMaintenanceRecords:
    "Equipment Lifecycle Documentation and Maintenance Records",
  moveToName: "Move to {name}",
  refresh: "Refresh",
  responsibility: "Responsibility",
  causeCategory: "Cause category",
  saveMultipleInstances: "Create multiple instances",
  chooseAmountOfInstances: "Choose the amount of instances you want to create ",
  nOfmInstancesCreated: "{n} of {m} instances created",
  machineRestrictions: "Machine restrictions",
  install: "Install",
  field: "Field",
  value: "Value",
  visible: "Visible",
  editProperty: "Edit property",
  machineRestrictionCreateDialogDescription:
    "Machine restrictions allow the restriction of input values for a template on a machine. Please select the template you want to restrict the inputs for.",
  hidden: "Hidden",
  locked: "Locked",
  editMachineRestrictionName: "Edit machine restriction {name}",
  createMachineRestriction: "Create machine restriction",
  installedOnTheDevice: "Installed on this device",
  uninstall: "Uninstall",
  replaceMachineRestriction: "Replace machine restriction",
  replaceMachineRestrictionDetails:
    "Installing the machine restriction {newName} would replace the existing machine restriction {oldName} on this machine.",
  german: "German",
  english: "English",
  qrCodeOutdated: "This QR code is not active anymore",
  sopActivationExplanation:
    "Activating a tasks version fixes its current content which cannot be edited anymore. A new version must be created if changes are required. Only active versions can be selected in the configuration of maintenance plans.",
  interventionPeriod: "Intervention period",
  images: "Images",
  noImages: "No images",
  notFound: "This page does not exist",
  accessDenied: "Access denied",
  apps: "Apps",
  dashboard: "Dashboard",
  dashboards: "Dashboards",
  dashboardsComingSoon: "Dashboards will be available soon.",
  assetDashboard: "Asset Dashboard",
  availability: "Availability",
  mtbf: "MTBF",
  mtbfLong: "Mean Time Between Failures",
  mttr: "MTTR",
  mttrLong: "Mean Time To Repair",
  maintenanceRatio: "Maintenance Ratio",
  preventive: "Preventive",
  corrective: "Corrective",
  spindleTemperature: "Spindle Temperature",
  vibration: "Vibration",
  powerConsumption: "Power Consumption",
  last7Days: "Last 7 Days",
  warningThreshold: "Warning",
  limitThreshold: "Limit",
  hybridProductionTitle: "Hybrid Production & Financial Indices",
  liveTelemetrySapCo: "Live Telemetry & SAP CO",
  oeeFinancialized: "OEE (Financialized)",
  oeeDescription:
    "Combines availability, performance, and quality. Direct link to unabsorbed overhead costs.",
  optimalRuntime: "Optimal Runtime",
  optimalRuntimeDescription:
    "Share of operating time at theoretical maximum cycle time. Declines indicate margin losses.",
  throughputPpm: "Throughput (PPM)",
  throughputDescription:
    "Parts per minute. High speed directly reduces fixed manufacturing costs per unit.",
  firstPassYield: "First Pass Yield (FPY)",
  firstPassYieldDescription:
    "Quality metric. High FPY eliminates scrap costs and rework effort.",
  maintenanceCostPerUnit: "Maint. Cost per Unit",
  maintenanceCostDescription:
    "Core operational metric. Sourced directly from SAP Universal Journal.",
  maintenanceCostRatio: "MC / RV",
  maintenanceCostRatioDescription:
    "Maintenance costs vs. estimated replacement value. Justifies new CapEx over repairs.",
  mtbfDescription:
    "Mean operating time between failures. Predictability ensures production schedule adherence.",
  preventiveCompliance: "Preventive Compliance",
  preventiveComplianceDescription:
    "Leading indicator. High compliance correlates strongly with zero catastrophic failures.",
  perMinute: "/ Min",
  hoursUnit: "Hrs",
  addDashboard: "Add Dashboard",
  noDashboardsYet: "No dashboards yet",
  noDashboardsYetDescription:
    "Create your first dashboard to visualize and monitor your data.",
  createFirstDashboard: "Create first dashboard",
  dashboardTitle: "Dashboard Title",
  dashboardCreated: "Dashboard created successfully",
  dashboardSettingsSaved: "Dashboard settings saved",
  failedToLoadDashboard: "Failed to load dashboard",
  failedToSaveSettings: "Failed to save settings",
  noDashboardItems: "No dashboard items yet",
  addDashboardItem: "Add Dashboard Item",
  selectItemTypePrompt: "Select the type of item you want to add:",
  twinTextOverview: "Twin Text Overview",
  twinTextOverviewDescription: "Display twin properties in a text format",
  richText: "Text",
  richTextDescription: "Display static text",
  richTextContentPlaceholder: "Enter text...",
  textSize: "Text size",
  textColor: "Text color",
  backgroundColor: "Background color",
  imageDashboardItem: "Image",
  imageDashboardItemDescription: "Display an uploaded image",
  selectImage: "Select image",
  replaceImage: "Replace image",
  imageUnavailable: "No image selected",
  objectFit: "Image fit",
  objectFitContain: "Contain",
  objectFitCover: "Cover",
  failedToDeleteImageDocument: "Failed to delete image document",
  dqKpiPercentage: "DQ KPI Percentage",
  dqKpiPercentageDescription: "Display data quality errors as a percentage",
  dqKpiTotal: "DQ KPI Total",
  dqKpiTotalDescription: "Display data quality errors as a total count",
  dqAnomalousEntries: "DQ Anomalous Entries",
  dqAnomalousEntriesDescription:
    "Display anomalous entries for a database field",
  itemCreatedSuccessfully: "Item created successfully",
  failedToCreateItem: "Failed to create item",
  itemDeletedSuccessfully: "Item deleted successfully",
  failedToDeleteItem: "Failed to delete item",
  itemUpdatedSuccessfully: "Item updated successfully",
  failedToUpdateItem: "Failed to update item",
  deleteItem: "Delete item",
  failedToSaveLayoutChanges: "Failed to save layout changes",
  gridSize: "Columns × Rows",
  gridMargin: "Margin X × Y",
  gridMinSize: "Min Size W × H",
  fixedSize: "Width × Height",
  marginX: "Margin X",
  marginY: "Margin Y",
  minWidth: "Min Width",
  minHeight: "Min Height",
  fixedWidth: "Fixed Width",
  fixedHeight: "Fixed Height",
  selectPurpose: "Select Purpose",
  dataQuality: "Data Quality",
  maintenanceOverview: "Maintenance Overview",
  tmAggregateBarChart: "Ticket Aggregation",
  tmAggregateBarChartDescription: "Bar chart grouped by a ticket property",
  tmTimeAggregateBarChart: "Ticket Timeline",
  tmTimeAggregateBarChartDescription: "Ticket count over time buckets",
  aggregationProperty: "Group by",
  statusTransitionValue: "Status",
  statusTransitionMode: "Mode",
  bucketSize: "Bucket Size",
  addFilter: "Add Filter",
  filters: "Filters",
  fixedFilters: "Filters",
  filterCustomId: "Property",
  filterValues: "Values",
  current: "Current",
  transitioned: "Transitioned",
  quarter: "Quarter",
  week: "Week",
  timeframe: "Timeframe",
  lastWeek: "Last Week",
  lastMonth: "Last Month",
  lastQuarter: "Last Quarter",
  lastYear: "Last Year",
  timeframeLast12Months: "Last 12 months",
  timeframeLastQuarter: "Last quarter",
  timeframeLast30Days: "Last 30 days",
  timeframeLast7Days: "Last 7 days",
  timeframeYearToDate: "Year to date",
  timeframePreviousYear: "Last year",
  bucketQuarter: "Quarter",
  bucketMonth: "Month",
  bucketWeek: "Week",
  bucketDay: "Day",
  chartLoadError: "Failed to load chart data",
  layoutSettings: "Layout Settings",
  sizeMode: "Size Mode",
  fullWidth: "Full Width",
  fullHeight: "Full Height",
  auto: "Auto",
  fixed: "Fixed",
  scroll: "Scroll",
  kiosk: "Kiosk / Full Screen",
  layoutMode: "Layout Mode",
  gridRowHeight: "Row Height (px)",
  verticalCompact: "Compact Vertically",
  sizeModeScrollDescription: "Fixed row height, content scrolls vertically.",
  sizeModeFullWidthDescription:
    "Always fills full viewport width, scrolls vertically.",
  sizeModeFullHeightDescription:
    "Fits exactly to screen height — ideal for wall displays and kiosk screens.",
  sizeModeFixedDescription: "Exact pixel dimensions for width and height.",
  general: "General",
  deleteDashboard: "Delete Dashboard",
  confirmDeleteDashboard:
    "Do you really want to delete this dashboard? This action cannot be undone.",
  dashboardDeleted: "Dashboard deleted successfully",
  failedToDeleteDashboard: "Failed to delete dashboard",
  thisUserHasNoApps: "This user has currently no access to any apps.",
  notifications: "Notifications",
  notification: "Notification",
  addSubscription: "Add Subscription",
  subscribers: "Subscribers",
  subscriptionAdded: "Subscription added",
  subscriptionRemoved: "Subscription removed",
  subscriptionUpdated: "Subscription updated",
  noEventsInThisApp: "This app doesnät support notifications",
  groupAlreadySubscribed: "This group is already subscribed",
  subscribe: "Subscribe",
  currentlyNoSubscriptions:
    "This notification has no subscribers. Click on {0} to add subscribers.",
  contacts: "Contacts",

  countryCode: "Country code",
  phoneNumber: "Phone number",
  street: "Street",
  numberShort: "No.",
  areaCode: "Area code",
  city: "City",
  country: "Country",
  address: "Address",
  addEmail: "Add e-mail",
  addAddress: "Add address",
  addPhone: "Add phone number",
  contributors: "Contributors",
  contributing: "Contributing",
  andNMore: "+{n} more",
  endEdit: "End editing",
  addContact: "Add contact",
  company: "Company",
  person: "Person",
  attachments: "Attachments",
  editSubscription: "Edit subscription",
  registrationNumber: "Registration number",
  vatId: "Vat ID",
  userInformation: "User information",
  plannedFinishDescription:
    "Planned finish of maintenance. The date will be used in the calendar as the end date of the maintenance. Future tickets will be created after the planned finish after {repetition}",
  plannedStart: "Planned start",
  plannedDuration: "Planned duration",
  to: "to",
  ticketHistory: "Ticket timeline",
  commented: "Commented",
  editedBy: "Edited by",
  newComment: "New comment",
  deletedBy: "Deleted by",
  changedTo: "changed to",

  hasAddedrelationToValue: "has added a relation to {value}",
  hasDeletedRelationToValue: "has removed a relation to {value}",
  hasAddedDocumentName: "has added the document {name}",
  hasDeletedDocumentName: "has removed the document {name}",
  hasAddedImage: "has added and image",
  hasDeletedImage: "has removed an image",

  oee: "OEE",
  outdatedVersionReloadPage:
    "You are using an outdated version. Click here to refresh the page and load the new version.",
  confirmRemoveUserFromGroup:
    "Are you sure you want to remove the user from the group {name}?",
  addGroup: "Add group",

  hasAddedSopName: "has added tasks {name}",
  hasDeletedSopName: "has removed tasls {name}",
  hasAddedSopInstanceName: "has added a task instance {name}",
  hasDeletedSopInstanceName: "has removed a task instance {name}",
  hasAddedTasklistName: "has added the task list {name}",
  hasDeletedTasklistName: "has removed the task list {name}",
  hasUpdatedTasklistName: "has updated the task list {name}",
  hasAddedTasklistItemIn: "has added an item in {name}",
  hasDeletedTasklistItemIn: "has removed an item in {name}",
  hasUpdatedTasklistItemIn: "has updated an item in {name}",

  commentUpdated: "Comment updated",
  commentDeleted: "Comment deleted",

  editOriginal: "Edit original",
  contactCreatedButCompanyRelationNotCreated:
    "The contact was created but it could not be associated to the company. Please try again to associate the contact with the company.",
  maintenancePlan: "Maintenance plan",
  addCompany: "Unternehmen hinzufügen",
  hasSetNameToValue: "has set {name} to {value}",
  hasChangedNameFromOldValueToNewValue:
    "has changed {name} from {oldValue} to {newValue}",
  removed: "removed",
  hasAddedMaterialComsumptionName: "hat added {name} as material consumption",
  thisTwinHasNoLifecycleData:
    "This object has no history. This is the case for objects created before March 2025",
  changelogs: "Changelogs",
  addDocuments: "Add documents",
  knowledgeSpaces: "Knowledge spaces",
  addKnowledgeSpace: "Add knowledge space",
  knowledgeDocuments: "Knowledge documents",
  users: "Users",
  confirmYouWantToRemoveNameFromSpace:
    "Please confirm you want to remove {name} from {space}",
  addFilesDialogHelper:
    "Use the drag and drop area to add files, either by drag and drop or by clicking. The files will be uploaded after a click on the upload button.",
  documentsAlreadyInList:
    "The following documents were not added because they are already in the list: {names}",
  targetUnitRequiredForFiles:
    "A target knowledge unit must be selected for the following files: {names}",
  duplicateNewVersionOfTarget:
    "The following knowledge unit was selected as target for 'New version of' more than once: {names}",
  namelessDocument: "Document without name",
  chats: "Chats",
  addChat: "Ask a question",
  moreOptions: "More options",
  dateRange: "Date range",
  typeAMessage: "Type a question...",
  knowledgeSpace: "Knowledge space | Knowledge spaces",
  question: "Question",
  chat: "Chat",
  knowledgeUnits: "Knowledge database",
  startNewChat: "Start a new chat",
  errorLoadingMessages:
    "Error loading previous messages, you can still ask new questions.",
  summary: "Summary",
  member: "Member",
  steward: "Steward",
  owner: "Owner",
  manageKnowledgeUnits: "Manage knowledge units",
  addKnowledgeUnit: "Add knowledge unit",
  withRole: "with role",
  uploadDocuments: "Upload documents",
  accessToKnowledgeSpaceRevoked: "Access to knowledge space has been revoked",
  noChats: "No chats yet",
  noConversations: "No conversations",
  noConversationsFound: "No conversations found",
  archived: "Archived",
  open: "Open",
  turns: "{count} turns",
  lastActivity: "Last activity: {date}",
  confirmRemoveDocumentFromSpace:
    "Are you sure you want to remove the document from this space? The document will still be available in other spaces.",
  remove: "remove",
  textOptions: "Text options",
  maxLength: "Maximum length",
  singleLine: "Single line",
  multiLine: "Multiline",
  rows: "Rows",
  aiSearchable: "Visible for AI",
  clickOrDropHere: "Click or drop a file here",
  knowledgeUnitsUsedForReply: "Knowledge units used for reply",
  changesSavedSuccessfully: "Changes saved successfully",
  thinking: "Thinking...",
  confirmRemoveKnowledgeSpace:
    "Are you sure you want to remove knowledge space {spaceName}?",
  createNewKnowledgeUnit: "Create new knowledge unit",
  newVersionOf: "New version of",
  referenceFor: "Reference for",
  detectingSimilarUnit: "Detecting similar unit...",
  targetKnowledgeUnit: "Knowledge unit",
  addExistingKnowledgeUnit: "Add existing knowledge unit",
  addUnitsDialogHelp: `This dialog lets you add or remove existing knowledge units from the current space. 
    It shows all units you have access to. Use the toggle switch on the right to add or remove a unit from this space.`,
  addUnitsDialogHelpExample:
    "This can be used to add units that are commonly used e.g. company wide guidelines or regulations.",
  editKnowledgeUnits: "Edit knowledge units",
  thoughts: "Thoughts",
  available: "Available",
  addNewVersion: "Add new version",
  documentDetails: "Document details",
  versions: "Versions",
  onlyDocumentsWithStatusDoneCanBeActivated:
    "This version can't be activated since it hasn't been processed yet",
  thisChatIsBasedOnOutDatedInformation:
    "This chat is based on outdated information, so no further questions can be asked.",
  details: "Details",
  section: "Section",
  errorLoadingSuggestedQuestions: "Suggested questions could not be loaded",
  suggestedQuestions: "Suggested Questions",
  addQuestion: "Add question",
  testThisQuestion: "Test this question",
  editQuestion: "Edit question",
  createName: "Create {name}",
  newEntry: "New entry",
  uploadImage: "Upload image",
  documentUploadedSuccessMessage: "Document upload succesfull",
  inactive: "Inactive",
  automaticCorrection: "Automatic correction",
  generatingCorrection: "Generating correction",
  automaticServicesUnavailable: "Automated services unavailable",
  automaticCorrectionRestart: "Autocorrect error, click to restart",
  automaticCorrectionAvailable: "Autocorrection available",
  deleteCorrection: "Delete autocorrection",
  saveAutoCorrection: "Save autocorrection",
  versionManagement: "Version management",
  versionNameActivatedClickHereToViewThisVersion:
    "Version {name} activated. Click here to edit this version.",
  retry: "Retry",
  deleteSuccess: "Successfully removed",
  exportStarted: "Export started",
  exportStartedDescription:
    "The export is being prepared. This may take a while.",
  maintenanceReports: "Maintenance tickets",
  reportsOverview: "Reports Overview",
  confirmRemoveKnowledgeUnit:
    "Are you sure you want to remove the knowledge unit {name}?",
  knowledgeUnitCantBeDeletedBecauseItHasBeenActivated:
    "This knowledge unit can't be removed since it has already been activated.",
  databases: "Databases",
  updated: "Updated",
  records: "Records",
  good: "Good",
  warning: "Warning",
  critical: "Critical",
  connected: "Connected",
  tables: "Tables",
  tickets: "Tickets",
  completeness: "Completeness",
  accuracy: "Accuracy",
  consistency: "Consistency",
  validity: "Validity",
  score: "Score",
  method: "Method",
  scope: "Scope",
  llmSearchableWarningMessage:
    "Visibility for AI has been enabled, note that it might take some time until the existing fields are processed and visible.",
  databaseManagement: "Database management",
  filePreviewNotSupportedByYourBrowser:
    "Previewing this file is not supported by your browser",
  databaseConnectionCreated: "Database connection created",
  databaseConnectionUpdated: "Database connection updated",
  databaseConnectionDeleted: "Database connection deleted",
  databaseConnectionError: "Error creating database connection",
  databaseConnectionTested: "Database connection tested successfully",
  createDatabaseConnection: "Create database connection",
  editDatabaseConnection: "Edit database connection",
  table: "Table",
  databaseConnectionTestError: "Error testing database connection",
  testConnection: "Test connection",
  databaseConnectionTestSuccess: "Database connection test successful",
  databaseConnectionTestSuccessMessage: "Database connection test successful",
  connectionStatus: "Connection status",
  connectionError: "Connection error",
  goToDatabaseManagement: "Go to database management",
  moreDetails: "More details",
  lessDetails: "Less details",
  sort: "Sort",
  scoped: "Scopes",
  host: "Host",
  port: "Port",
  database: "Database",
  redirectingToLogin: "Redirecting to login page...",
  loggingIn: "Logging in...",
  errorLoggingIn: "Error logging in",
  backToLogin: "Back to login",
  enabled: "Enabled",
  disabled: "Disabled",
  analysis: "Analysis",
  minScore: "Minimale Bewertung",
  maxScore: "Maximale Bewertung",
  appIsManaged: "Automatic management",
  appIsManagedDescription:
    "Automatic management through smx. If activated any edits might be overridden by smx.",
  appIconTooLarge: "App Icon is too large. Maximum size is 300Kb.",
  columns: "Columns",
  update: "Update",
  addNote: "Add note",
  note: "Note",
  enterNote: "Enter note...",
  kpiThresholds: "Thresholds",
  start: "Start",
  end: "End",
  fieldDeactivated: "Field deactivated",
  fieldDeactivatedDescription:
    "This field has been deactivated and is no longer analyzed",
  deactivateFieldExplanation:
    "Deactivating this field will exclude it from analysis and reporting.",
  downloadExcel: "Download Excel",
  more: "More",
  stop: "Stop",
  downloadDocument: "Download document",
  changes: "Changes",
  noteSaved: "Note saved successfully",
  schedule: "Schedule",
  productionTickets: "Production tickets",
  maintenanceTickets: "Maintenance tickets",
  deactivated: "Deactivated",
  anomaliesDashboard: "Anomaly-Dashboard",
  notStartedYet: "Not started yet",
  createReport: "Create report",
  addReport: "Add report",
  twinReportPrefixRequired: "A template or type must be selected.",
  twinReportIdFilter: "ID filter",
  twinReportModifiedFilter: "Modified at filter",
  twinReportCreatedFilter: "Created at filter",
  twinReportDescription: "Description",
  twinReportCreated: "Created",
  widgetTitleDescription:
    "Widget title, if not specified, the name of the Field will be used as title.",
  widgetDescriptionDescription:
    "Description of the widget and what the anomalies indicate. Displayed on the widget.",
  widgetInformationDescription:
    "Additional information, displayed as a popover and should include what the user can do when they see an anomaly.",
  widgetKpiNameDescription:
    "Name of the KPI. If not specified, the default name of the KPI will be used.",
  addReportSheet: "Add sheet",
  selectAssetOrType:
    "Determines which machines, assets, or devices are considered in the report. The selection can be made via a template or by entering a type. Use the asterisk * as a wildcard for any letters or numbers.",
  selectTicketOrType:
    "Determines which tickets are considered in the report. The selection can be made via a template or by entering a type. Use the asterisk * as a wildcard for any letters or numbers.",
  workOrder: "Work order",
  workOrders: "Work orders",
  size: "Size",
  uploadFailed: "Upload failed",
  cancelUploads: "Cancel uploads",
  cancelUploadsConfirm: "Uploads are in progress. Cancel them and close?",
  cancelUploadsYes: "Cancel uploads",
  cancelUploadsNo: "Keep uploading",
  dangerousActions: "Dangerous actions",
  agentSettings: "Agent settings",
  noAgentsAvailable: "No agents available",
  products: "Products",
  mechanicalAcceptanceReports: "Mechanical Acceptance Reports",
  electricalAcceptanceReports: "Electrical Acceptance Reports",
  technicalData: "Technical Data",
  admin: "Admin",
  ticketOrigin: "Parent ticket",
  errorLoadingFiles: "Error loading files",
  uploadFiles: "Upload files",
};
